<template>
  <PurchasePlan />
</template>

<script>
import PurchasePlan from '@/components/PurchasePlan/PurchasePlan';

export default {
  components: {
    PurchasePlan
  },
  nuxtI18n: {
    paths: {
      en: '/purchase-plan/:id/:keyword'
    }
  },
  async fetch({ redirect, store, route, $urlBuilder, $cookies }) {
    const plan = await store.dispatch('plans/GET_PLAN', route.params.id);
    if (plan) {
      store.dispatch('plans/OPEN_PLAN', plan);
      $cookies.set('vx.plan', plan);
    } else {
      redirect(301, $urlBuilder('plans'));
    }
  },
  head() {
    const id = this.$route.params.id;
    const i18nSeo = this.$seoPlugin({ slash: true });
    const canonicalLink = this.$trailingSlash(
      this.localePath({ name: 'purchase-plan-id', params: { id } })
    );
    return {
      title: this.$t('purchase.plans.seo.metaTitle', { number: this.$route.params.id }),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('purchase.plans.seo.metaDescription', { number: this.$route.params.id })
        },
        { hid: 'robots', name: 'robots', content: 'noindex' }
      ],
      link: [
        {
          hid: 'i18n-can',
          href: canonicalLink,
          rel: 'canonical'
        },
        ...i18nSeo.link
      ]
    };
  }
};
</script>
